<template>
  <confirm-dialog
    :show="show"
    :message="message"
    @accept="deleteWorkflow"
    @close="$emit('close')">
  </confirm-dialog>
</template>
 
<script>
import ConfirmDialog from '@/components/global/ConfirmDialog';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    workflow: {
      type: Object,
      required: true,
    },
  },
  components: {
    ConfirmDialog,
  },
  computed: {
    message() {
      return `¿Esta seguro de que desea eliminar el flujo ${this.workflow.name}? Se borraran todas las etapas y filtros asociados, esta acción no se puede deshacer.`;
    },
  },
  methods: {
    deleteWorkflow() {
      this.axios.delete(`workflows/${this.workflow.id}`)
        .then(() => {
          this.$emit('deleted');
        }).catch(() => {});
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/CollectWorkflows/DeleteWorkflow.vue